import React from "react";

import { Text } from "@ui/Atoms/Text";

import { Markdown } from "@containers/Markdown";

import { useTranslate } from "@hooks/useTranslate";

import * as Styled from "./Header.styled";

interface Props {
  className?: string;
}

export const Header: React.FC<Props> = props => {
  const translate = useTranslate("batmaid_pwa_static_homepage");

  return (
    <Styled.Root className={props.className}>
      <Text
        as="h2"
        $style={{
          default: "bold_40",
          smallTablet: "bold_56",
          smallDesktop: "bold_72",
        }}
        $breakWord
      >
        <Markdown>{translate("extras_heading")}</Markdown>
      </Text>

      <Text
        as="p"
        $style={{
          default: "regular_16",
          smallDesktop: "regular_18",
        }}
      >
        {translate("extras_description")}
      </Text>
    </Styled.Root>
  );
};
